import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { UserState } from '@shared/states/user.state';

export const UserStateResolver: ResolveFn<void> = (): Observable<void> => {
  return inject(UserState).loadIfRequired();
};
